import { QueryList, EventEmitter } from '@angular/core';
import { AchooTabComponent } from './achoo-tab/achoo-tab.component';
import { TabInkBarDirective } from './tab-ink-bar.directive';
import { TabLabelWrapperDirective } from './tab-label-wrapper.directive';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
var AchooTabsComponent = /** @class */ (function () {
    function AchooTabsComponent() {
        var _this = this;
        this.tabClicked = new EventEmitter();
        this.debouncer = new Subject();
        this.debouncer.debounceTime(100)
            .subscribe(function (tab) {
            _this.alignInkBar();
        });
    }
    Object.defineProperty(AchooTabsComponent.prototype, "selectedTabKey", {
        get: function () {
            return this.currentSelectedTabId;
        },
        set: function (value) {
            this.currentSelectedTabId = value;
            if (!this.tabs) {
                return;
            }
            this.selectTab(this.getSelectedTab(), true);
        },
        enumerable: true,
        configurable: true
    });
    AchooTabsComponent.prototype.ngAfterViewChecked = function () {
        var _this = this;
        if (!this.tabs) {
            return;
        }
        this.tabs.forEach(function (x) { return x.changed.subscribe(function (tab) {
            _this.debouncer.next(tab);
        }); });
        var activeTabs = this.tabs.filter(function (x) { return x.active; });
        if (activeTabs.length === 0) {
            this.selectTab(this.getSelectedTab(), true);
        }
    };
    AchooTabsComponent.prototype.getSelectedTab = function () {
        var _this = this;
        if (!this.tabs) {
            return null;
        }
        return this.tabs.find(function (x) { return x.tabKey === _this.selectedTabKey; }) || this.tabs.first;
    };
    AchooTabsComponent.prototype.selectTab = function (tab, isCheckComponentView) {
        var _this = this;
        var activeTab = tab || this.getSelectedTab();
        if (!activeTab) {
            return;
        }
        // Emit selected tab to parent component
        if (!isCheckComponentView) {
            this.tabClicked.emit(activeTab.tabKey);
        }
        var doActivateSelectedTab = function () {
            // Deactive all tabs
            _this.tabs.toArray().forEach(function (x) { return x.active = false; });
            _this.currentSelectedTabId = activeTab.tabKey;
            // Active selected tab
            activeTab.active = true;
            // Update ink-bar to current selected tab
            _this.alignInkBar();
        };
        // Update follow-bar
        // Reference URL: http://blog.teamtreehouse.com/efficient-animations-with-requestanimationframe
        if (typeof requestAnimationFrame !== 'undefined') {
            requestAnimationFrame(function () { return doActivateSelectedTab(); });
        }
        else {
            // This will run out of main thread and make the UI update smoothly
            setTimeout(function () { return doActivateSelectedTab(); }, 0);
        }
    };
    AchooTabsComponent.prototype.delayUpdate = function () {
        this.debouncer.next(null);
    };
    AchooTabsComponent.prototype.alignInkBar = function () {
        var selectedTab = this.getSelectedTab(), tabIndex = this.tabs.toArray().indexOf(selectedTab);
        var selectedLabelWrapper = this.labelWrappers && this.labelWrappers.length
            ? this.labelWrappers.toArray()[tabIndex].elementRef.nativeElement
            : null;
        if (!selectedLabelWrapper) {
            this.inkBar.hide();
            return;
        }
        this.inkBar.alignToElement(selectedLabelWrapper);
    };
    return AchooTabsComponent;
}());
export { AchooTabsComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/achoo-tabs.component.ts.pre-build-optimizer.js